export default __webpack_public_path__ + "static/media/top_service.bbbc4966.png";